import { ModalProps } from '@tryhackme/thm-ui-components';

import { RoomDetailsData } from '../../room.types';

export interface RoomsCompletionModalProps extends ModalProps {
  currentRoom?: RoomDetailsData;
  roomCode: string;
  setIsConfettiVisible: (arg: boolean) => void;
  isOpenModal?: boolean;
  hasEventTickets?: boolean;
}

export interface RoomFeedbackInput {
  like: string;
  dislike: string;
  feature: string;
}

export interface CampaignProps {
  utm_source?: string;
  utm_campaign: string;
  utm_medium: string;
}

export enum SocialName {
  TWITTER = 'twitter',
  FACEBOOK = 'facebook',
  LINKEDIN = 'linkedin',
}

export type CongratulationStep = {
  currentRoom?: RoomDetailsData;
  roomCode: string;
  hasEventTickets?: boolean;
};
